/** @jsxImportSource theme-ui */
import { Card, Container } from 'theme-ui';
import NewsletterBroadcast from '@/containers/newsletterBroadcast/NewsletterBroadcast';

const NewsletterBroadcastPage: React.FC = () => {
    return (
        <Container>
            <Card variant="widget" p={3}>
                <NewsletterBroadcast />
            </Card>
        </Container>
    );
};

export default NewsletterBroadcastPage;
